/**
 * @title Profile page
 * @description The personal information about the consumer that is trading in an item
 * @image https://storageaccountourimbea2.blob.core.windows.net/tradein2guide/profile.png
 */
import * as React from "react";
import {FC, useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {PrivateRenderer} from "../PrivateRenderer";
import {ReturnsCartAtom} from "../returns/ReturnsCart";
import {StyledDiv, StyledTypography} from "../../../providers/layout/LayoutProvider";
import {makeStyles} from "@mui/styles";
import {ConsumerForm} from "./ConsumerForm";
import {useRecoilValue} from "recoil";
import {AccessContextData} from "../../../providers/access/AppContextProvider";
import {LocalizationsAtom} from "../../../providers/localization/LocalizationProvider";
import {ReturnsPagePath} from "../returns/ReturnsPage";
import {CircularProgress} from "@mui/material";

export const ProfilePagePath = () => {
   return ReturnsPagePath() + "/profile";
}

export const ProfilePage: FC<any> = () => {
   const localizations = useRecoilValue(LocalizationsAtom);
   const {accessToken} = useParams<{ accessToken: string }>();
   const cart = useRecoilValue(ReturnsCartAtom);
   const appContext = useRecoilValue(AccessContextData);
   const classes = useStyles();
   const navigate = useNavigate();
   const isHidden = !!window.useExternalCustomerData;

   useEffect(() => {
      if (cart === null || cart.potentials.length === 0) {
         navigate('/' + accessToken);
      }
   }, [accessToken, cart, navigate])

   return <PrivateRenderer step={"profile"}>
      <StyledDiv type={"main"} className={classes.page}>
         {isHidden && <CircularProgress sx={{color: '#C0C0C0'}}/>}
         <div className={classes.pageTitle} style={{display: isHidden ? 'none': 'initial'}}>
            <StyledTypography variant={"h1"}>
               {localizations.profileTitle}
            </StyledTypography>
            <StyledTypography variant={"body1"} style={{marginTop: '10px'}} dangerouslySetInnerHTML={{__html: localizations.profileDescription}}/>
         </div>
         <div className={classes.profileContainer}>
            <ConsumerForm shopId={appContext.shopId} consumerId={appContext.consumerId!}/>
         </div>
      </StyledDiv>
   </PrivateRenderer>
}


const useStyles = makeStyles({
   page: {
      display: 'flex',
      width: '100%',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'start',
   },
   profileContainer: {
      width: '600px'
   },
   pageTitle: {
      width: '600px',
      textAlign: 'center',
      marginBottom: '20px'
   },
   '@media only screen and (max-width: 800px)': {
      pageTitle: {
         width: '90%',
         maxWidth: '440px'
      },
      profileContainer: {
         width: '80%'
      }
   },

});
